import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { slugify } from "../helpers";
import VisibilitySensor from "react-visibility-sensor";

class IndustriesTile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasAppeared: false
        };

        this.toggleActive = this.toggleActive.bind(this);
    }

    toggleActive(isVisible) {
        isVisible === true ? this.setState({ hasAppeared: true }) : "";
    }

    render() {
        const slug = this.props.industries.name,
            sanitized = slugify(slug),
            url = `/industries/${sanitized}/`;

        return (
            <VisibilitySensor onChange={this.toggleActive}>
                {({ isVisible }) => (
                    <Link
                        className={`tile__link ${
                            this.state.hasAppeared ? "is-visible" : ""
                        }`}
                        to={{ pathname: url }}
                        data-cta={`Search Tile: By Industry: ${slug}`}
                    >
                        <article className="tile">
                            <div className="tile__content-container">
                                <figure className="tile__fig">
                                    <img
                                        src={this.props.industries.icon}
                                        alt={this.props.industries.name}
                                        className="tile__img"
                                    />
                                </figure>
                                <h3 className="tile__name">{slug}</h3>
                            </div>
                        </article>
                    </Link>
                )}
            </VisibilitySensor>
        );
    }
}

export default IndustriesTile;



// WEBPACK FOOTER //
// ./src/components/IndustriesTile.js